import React from 'react';

import { Modal, TitleBar } from '@shopify/app-bridge-react';
import { SkeletonBodyText } from '@shopify/polaris';

function AppModal({
    title = null,
    cancelLabel = null,
    confirmLabel = null,
    confirmAction = () => {},
    confirmEnabled = true,
    processing = false,
    children = [],
}) {
    return (
        <Modal id="locations-modal">
            <TitleBar title={title}>
                {cancelLabel && (
                    <button disabled={processing} onClick={() => shopify.modal.hide('locations-modal')}>
                        {cancelLabel}
                    </button>
                )}
                {confirmLabel && (
                    <button disabled={processing || !confirmEnabled} onClick={confirmAction} variant="primary">
                        {confirmLabel}
                    </button>
                )}
            </TitleBar>
            {<div style={{ margin: '1.5em 1.25em' }}>{children}</div>}
        </Modal>
    );
}

export default AppModal;
